module.exports = __webpack_public_path__ + "static/media/the_barn_on_66_small.7f1f2627.jpg";